(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mf-header')) {
    class MfHeader extends HTMLElement {
      connectedCallback() {
        this.burger = this.querySelector('[data-mf-burger]');
        this.menu = this.querySelector('[data-mf-menu]');
        this.mobileQuery = window.matchMedia(
          'screen and (max-width: 799px), screen and (pointer: coarse) and (max-width: 1024px)'
        );

        this.onBurger = () => (this.isOpen ? this.close() : this.open());
        this.onKey = (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close(true);
        };
        this.onQuery = (event) => {
          if (!event.matches && this.isOpen) this.close();
        };

        this.burger?.addEventListener('click', this.onBurger);
        document.addEventListener('keydown', this.onKey);
        this.mobileQuery.addEventListener('change', this.onQuery);

        /* Publish the header height for sections that sit under it.
           --header-height keeps Dawn components that rely on it working. */
        this.resizeObserver = new ResizeObserver(() => {
          const height = `${this.offsetHeight}px`;
          document.documentElement.style.setProperty('--mf-header-height', height);
          document.documentElement.style.setProperty('--header-height', height);
        });
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.close();
        this.burger?.removeEventListener('click', this.onBurger);
        document.removeEventListener('keydown', this.onKey);
        this.mobileQuery?.removeEventListener('change', this.onQuery);
        this.resizeObserver?.disconnect();
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      open() {
        this.classList.add('is-open');
        this.menu.removeAttribute('inert');
        this.menu.setAttribute('aria-hidden', 'false');
        this.burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mf-menu-open');
        this.menu.querySelector('a')?.focus({ preventScroll: true });
      }

      close(returnFocus = false) {
        if (!this.menu) return;
        this.classList.remove('is-open');
        this.menu.setAttribute('inert', '');
        this.menu.setAttribute('aria-hidden', 'true');
        this.burger?.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mf-menu-open');
        if (returnFocus) this.burger?.focus();
      }
    }

    customElements.define('mf-header', MfHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
